import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  dialogOpen: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
  handleDecline: () => void;
}

export const InfoDialogLeihbar = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog open={props.dialogOpen} scroll={'paper'}>
      <DialogTitle>{t(translations.pages.leihbar.terms.title())}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(translations.pages.leihbar.terms.text1())}
          <br />
          <br />
          {t(translations.pages.leihbar.terms.text2())}
          <Link
            sx={{ fontWeight: 'bold' }}
            target="_blank"
            href="https://www.th-rosenheim.de/studium-und-weiterbildung/im-studium/innovative-lehr-und-lernmethoden/e-learning-center/leihbar-nutzungsbedingungen"
          >
            {' '}
            {t(translations.pages.leihbar.terms.text3())}
          </Link>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleDecline} color="error" size="small" variant="outlined">
          Ablehnen
        </Button>
        <Button onClick={props.handleConfirm} color="primary" variant="contained" size="small">
          Akzeptieren
        </Button>
      </DialogActions>
    </Dialog>
  );
};
